<template>
  <div id="About">
    <h1>Cindy Quach</h1>
    <p>Hi! My name is Cindy and welcome to my online resume portfolio! <br>
      I am currently in my senior year at California State University Fullerton, studying Computer Science.
      One of the greatest things that I enjoy about my major is the ability to create my own digital
      worlds like this online resume!
      Please feel free to look around, and please don't hesitate to contact me if you'd like
      to know more about me!</p>
  </div>
</template>

<script>
export default {
  name: 'About' //this is the name of the component
}
</script>
<style>
#About {
border-style: solid;
}
</style>


// WEBPACK FOOTER //
// src/components/About.vue